import React, { useState, useEffect, useRef } from 'react'
import api from '../components/api'
import JoditEditor from "jodit-react"



const Modal = (props) => {


    var adesao_institucional_id = props.adesao_institucional_id

    var [titulo, setTitulo] = useState('Acesso Hospitais Saudáveis')
    var [texto, setTexto] = useState('')
    var [email, setEmail] = useState('')
    var [emailGerado, setEmailGerado] = useState(false)

    //var [linkRecuperacaoSenha, setLinkRecuperacaoSenha] = useState()
    
    
    //var [autor, setAutor] = useState(sessionStorage.getItem('nome'))
    //var ad_usr = sessionStorage.getItem('us_codigo')


    const editor = useRef(null)
    const [content, setContent] = useState('')


    const [config, setConfig] = useState({
        readonly: false,
        toolbar: true,
        height: 300,
        placeholder: 'Escreva aqui...',
      })

    async function carrega() {

        if (!isNaN(adesao_institucional_id)) {

            await api.get(`adesaoInstitucionalListaUm/${adesao_institucional_id}`).then((result) => {

                //console.log(result.data, '!!')
                setEmail(result.data[0].emailRepresentante)
                
                if (result.data[0].chaveLinkRecuperacaoSenha && emailGerado == true) {


                    var txt = `
                
                    Prezado <b>${result.data[0].nome_fantasia}</b>,<br><br>O Projeto Hospitais Saudáveis. Identificou que você solicitou o cadastramento de uma nova senha. Utilize o link abaixo para realizar o cadastramento de sua senha:<br><br>
                    
                    <a href='https://hospitaissaudaveis.org/3pqWx983!${result.data[0].chaveLinkRecuperacaoSenha}'>https://hospitaissaudaveis.org/3pqWx983!${result.data[0].chaveLinkRecuperacaoSenha}</a><br><br>
    
                    Atenciosamente,<br>
                    <font color="brown">Projeto Hospitais Saudáveis</font>
                    `


                }

               

                setContent(txt)

    
            }).catch((err) => {
    
                console.log(err.response)
    
            })


        }

        

    }


    function enviaMail() {


        if (titulo == '') {

            window.toastr.error('<b>T&iacute;tulo</b> não pode ficar em branco!')
            return false

        }

        if (email == '') {

            window.toastr.error('<b>E-mail</b> não pode ficar em branco!')
            return false

        }

        if (content == '') {

            window.toastr.error('<b>Texto</b> não pode ficar em branco!')
            return false

        }


        var dataPost = {

            adesao_institucional_id: adesao_institucional_id,
            titulo: titulo,
            texto: content,
            email: email,

        }

        //console.log(dataPost)
        //return false


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma enviar o e-mail?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)
    
                    api.post('adesaoInstitucionalEnviaMail', dataPost).then((result) => {

                        //console.log(result.data)
                        window.$("#ModalEmailSenha").modal('hide');
                        window.toastr.success('E-mail enviado com sucesso!')

                    }).catch((err) => {
                    
                        console.log(err)

                    })

                   

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }


    async function geraLinkRecuperacaoSenha() {


        await api.get(`geraLinkRecuperacaoSenha/${adesao_institucional_id}`).then((result) => {

            //console.log('!?')

            if (result.data.alerta != 'ok') {

                window.toastr.error('Ocorreu algum problema, por favor contacte o administrador do sistema')
                return false
            
            } else {

                
                
                setEmailGerado(true)

            }
            

        }).catch((err) => {

            console.log(err.response)

        })

    }

    useEffect(() => {

        carrega()

    }, [emailGerado])

    

    useEffect(() => {
        
        setTexto('')
        carrega()
        //geraLinkRecuperacaoSenha()

    }, [adesao_institucional_id])


    return (

        <div>

            <div className="modal fade" id="ModalEmailSenha" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 className="modal-title">E-mail</h1>
                        </div>
                        <div class="modal-body">
                                
                                <div className="panel-body">
                                    
                                    
                                <div className="col-md-12">
                                        <div class="form-group">
                                            <label>E-mail</label>
                                            <input type="text" value={email} onChange={event => setEmail(event.target.value)} className="form-control" placeholder="" maxLength={500} />
                                                            
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div class="form-group">
                                            <label>Título/Assunto</label>
                                            <input type="text" value={titulo} onChange={event => setTitulo(event.target.value)} className="form-control" placeholder="" maxLength={500} />
                                                            
                                        </div>
                                    </div>


                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>Texto</label>
                                                    
                                            <JoditEditor 
                                                ref={editor}
                                                value={content}
                                                config={config}
                                                tabIndex={1} // tabIndex of textarea
                                                onBlur={newContent => setTexto(newContent)} // preferred to use only this option to update the content for performance reasons
                                                onChange={newContent => {}}
                                            />

                                                            
                                        </div>

                                    </div>


                                    

                                </div>


                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <button type="button" className="btn btn-info" onClick={() => geraLinkRecuperacaoSenha()}>Gerar e-mail com link de alteração de senha</button>
                            <button type="button" className="btn btn-success" onClick={() => enviaMail()}>Enviar e-mail</button>
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )


}

export default Modal